import { gql } from 'graphql-request';

/**
 * Batched read of an organisation's existing draft RI sites, used by the
 * BC → RI site-import flow to decide, per project, whether to create a
 * fresh site or attempt geography recovery on an already-existing draft.
 *
 * Only `status: DRAFT` is fetched because the domain invariant
 * `active ⇒ has geography` means non-draft sites are never recovery
 * candidates — an active/archived BC-id conflict falls through to the
 * create path's 409 → Skipped branch. `geography` is selected only to
 * detect its non-null presence; the specific field (`countryName`) is
 * incidental.
 *
 * The engine caps `pageSize` at 100; the caller pages through until
 * `pagination.hasNext` is false via `fetchAllDraftSitesForImport`.
 */
export const riskPortfolioImportPreloadQuery = gql`
    query RiskPortfolioImportPreload($businessCentralId: String!, $page: Int!) {
        organisation(businessCentralId: $businessCentralId) {
            sites(status: DRAFT, page: $page, pageSize: 100) {
                items {
                    id
                    businessCentralId
                    geography {
                        countryName
                    }
                }
                pagination {
                    hasNext
                }
            }
        }
    }
`;

export type ImportPreloadSite = {
    id: string;
    businessCentralId: string | null;
    geography: { countryName: string | null } | null;
};

export type ImportPreloadPagination = {
    hasNext: boolean;
};

export type RiskPortfolioImportPreloadResult = {
    organisation: {
        sites: {
            items: ImportPreloadSite[];
            pagination: ImportPreloadPagination;
        } | null;
    } | null;
};
